import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContactDetails from "../ContactDetails.jsx";
import { activeBrand } from "../../theme/brands/index.js";

export default function ContactModal({ open, onClose }) {
  const contact = activeBrand.contact ?? {};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Kontakt
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ContactDetails
          label={contact.label}
          label_name={contact.name}
          label_funktion={contact.funktion}
          kontakt={{
            items: [
              { typ: "Telefon", nummer: contact.telefon },
              { typ: "Telefax", nummer: contact.fax },
              { typ: "E-Mail", nummer: contact.email },
            ],
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
